import React, {Component, Fragment} from 'react';

import Switch from "react-switch";




export default class TasSwitch extends Component {

	constructor(props) {
		super(props);
		this.state = {
			tomonote : this.props.tomonote,
			tomobooks : this.props.tomobooks,
			tomonoteCbFnc : this.props.tomonoteCbFnc,
			tomobooksCbFnc : this.props.tomobooksCbFnc
		}
	}


	componentWillReceiveProps = (nextProps) => {
        this.setState({
            tomonote : nextProps.tomonote,
			tomobooks : nextProps.tomobooks
        })
    }


	render() {
		return (
			<Fragment>
				<label className="mr-3">
	                <Switch onChange={this.state.tomonoteCbFnc} checked={this.state.tomonote} width={100}
	                    checkedIcon={
	                      <div
	                        style={{
	                          display: "flex",
	                          justifyContent: "center",
	                          alignItems: "center",
	                          height: "100%",
	                          fontSize: 15,
	                          color: "#FFFFFF",
	                          paddingRight: 2,
	                          width : "80px"
	                        }}
	                      >
	                        토모노트
	                      </div>
	                    }
	                    uncheckedIcon={
	                      <div
	                        style={{
	                          display: "flex",
	                          marginLeft : "-20px",
	                          alignItems: "center",
	                          height: "100%",
	                          fontSize: 15,
	                          color: "#FFFFFF",
	                          width : "80px"
	                        }}
	                      >
	                        토모노트
	                      </div>
	                    }
	                    className="react-switch"
	                />
	            </label>
	            <label className="mr-3">
	                <Switch
	                    onChange={this.state.tomobooksCbFnc}
	                    checked={this.state.tomobooks}
	                    width={100}
	                    onColor="#5969ff"
	                    checkedIcon={
	                      <div
	                        style={{
	                          display: "flex",
	                          justifyContent: "center",
	                          alignItems: "center",
	                          height: "100%",
	                          fontSize: 15,
	                          color: "#FFFFFF",
	                          paddingRight: 2,
	                          width : "80px"
	                        }}
	                      >
	                        토모동화
	                      </div>
	                    }
	                    uncheckedIcon={
	                      <div
	                        style={{
	                          display: "flex",
	                          marginLeft : "-20px",
	                          alignItems: "center",
	                          height: "100%",
	                          fontSize: 15,
	                          color: "#FFFFFF",

	                          width : "80px"
	                        }}
	                      >
	                        토모동화
	                      </div>
	                    }
	                    
	                    className="react-switch"
	                />
	            </label>
	        </Fragment>


		)
	}

}